if (!process.env.REACT_APP_FIREBASE_CONFIG) {
    throw new Error(
        "Missing required environment variable REACT_APP_FIREBASE_CONFIG"
    );
}
export const FIREBASE_CONFIG = JSON.parse(
    process.env.REACT_APP_FIREBASE_CONFIG
);



// WEBPACK FOOTER //
// ./src/config.js